import { render, staticRenderFns } from "./SimpleJobView.vue?vue&type=template&id=b4e53922&scoped=true&"
import script from "./SimpleJobView.vue?vue&type=script&lang=js&"
export * from "./SimpleJobView.vue?vue&type=script&lang=js&"
import style0 from "./SimpleJobView.vue?vue&type=style&index=0&id=b4e53922&prod&scoped=true&lang=css&"
import style1 from "./SimpleJobView.vue?vue&type=style&index=1&id=b4e53922&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e53922",
  null
  
)

export default component.exports